import { render, staticRenderFns } from "./my-beans.vue?vue&type=template&id=63a2ca89&scoped=true"
import script from "./my-beans.vue?vue&type=script&lang=js"
export * from "./my-beans.vue?vue&type=script&lang=js"
import style0 from "./my-beans.vue?vue&type=style&index=0&id=63a2ca89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a2ca89",
  null
  
)

export default component.exports